import SurveillanceItem from './SurveillanceItem';

export default SurveillanceItem;
